import { useSyncExternalStore } from "react";

const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
} as const;

type Breakpoint = keyof typeof BREAKPOINTS;

const subscribe = (callback: () => void) => {
  window.addEventListener("resize", callback);

  return () => window.removeEventListener("resize", callback);
};

const getSnapShot = () => window.innerWidth;

export const useMediaQuery = (breakpoint: Breakpoint = "MOBILE") => {
  const currentWidth = useSyncExternalStore(subscribe, getSnapShot);

  return currentWidth < BREAKPOINTS[breakpoint];
};
